import React, { useState } from "react";
import { Cascader } from "antd";
import '../css/hiddenPowerDropdown.css';
import statLabelMap from "../data/statLabelMap";

const normalizeValues = (values) =>
  Array.isArray(values) ? values : [values];

const buildCascaderOptions = (data) =>
  Object.entries(data)
    .reverse()
    .map(([rarity, attrs]) => ({
      value: rarity,
      label: rarity.charAt(0).toUpperCase() + rarity.slice(1),
      children: Object.entries(attrs)
        .map(([attr, values]) => ({
          value: attr,
          label: statLabelMap[attr] || attr,
          children: normalizeValues(values)
            .sort((a, b) => b - a)
            .map((val) => ({
              value: val,
              label: attr === 'ElementalATK' ? `+${val}` : `+${val}%`,
            })),
        })),
    }));



const HiddenPowerDropdown = ({ data, onChange }) => {
  const [selected, setSelected] = useState([]);
  
  const handleChange = (value) => {
    const safeValue = value || [];
    setSelected(safeValue);
    onChange(safeValue);
  };

  return (
    <div className={"hiddenPowerDropdown"}>
      <Cascader
        options={buildCascaderOptions(data)}
        value={selected}
        onChange={handleChange}
        placement="bottomLeft"
        classNames={{
          popup: {
            root: 'hiddenPowerCascader',
          },
        }}
        getPopupContainer={() => document.body}
      >
        <div
          className={`dropdownTrigger rarityText ${selected[0]?.toLowerCase() || ''}`}
          style={{
            width: '200px',
            padding: '8px',
          }}
        >
          <span className="black">▼ </span>
          {selected.length > 0 ? ` ${statLabelMap[selected[1]] || selected[1]} +${selected[2]}${selected[1] === 'ElementalATK' ? `` : `%`}` : " Click to select"}
        </div>
      </Cascader>
    </div>
  );
};

export default HiddenPowerDropdown;
